<template>
  <div class="">
      <div class="flex items-center pb-4">
        <div class="w-80 pr-5 text-xs text-black">
          <p class='py-1'>Search (Gift code, User Email)</p>
          <v-text-field placeholder="Name" variant="outlined" density="compact" v-model="searchData" rounded="0">
          </v-text-field>
        </div>
        <div class="w-80 pr-5 text-xs text-black">
            <p class='py-1'>Select View Method</p>

            <v-select v-model="selectedView" :items="viewList" density="compact"
                variant="outlined" placeholder="Select License Status" rounded="0"
                style="padding-top: 0px;padding-bottom: 0px;" class="bg-white text-black">

            </v-select>
        </div>
        <div class="w-full">
          <span
            v-for="cBalance in UserBalance"
            :key="cBalance.gift_country"
            class="badge text-bg-primary fs-15 m-1"
          >
            {{ cBalance.gift_country }} : $ {{ parseFloat(cBalance.total_balance).toFixed(2) }}
          </span>
          <v-btn size="small" style="outline: none;"
              class="bg-dark text-light float-end" @click="addGiftCode" data-bs-toggle="modal"
              data-bs-target="#giftCodeAddModal">Purchase</v-btn>
        </div>
      </div>
      <v-data-table 
        :headers="headers" 
        :items="GiftCodes.filter(giftElement => {
          const matchesSearch = [giftElement.giftCode, giftElement.user]
            .join(',')
            .toLowerCase()
            .includes(searchData.toLowerCase());

          if (selectedView === 'Purchase') {
            return matchesSearch && (giftElement.customerId == user.id)
          } else if (selectedView === 'Redeem') {
            return matchesSearch && (giftElement.user == user.email)
          } else {
            return matchesSearch
          }
        })"
        item-key="name" 
        class="border h-[500px] bg-white text-black min-h-[500px] " 
        items-per-page="-1"
        style="font-size: 13px;" 
        :style="`height: ${computedHeight}px;`"
      >
          <template v-slot:[`item.no`]="{ index }">
              {{ index + 1 }}
          </template>
          <template v-slot:[`item.buttonBar`]="{ item }" v-if="selectedView === 'Purchase'">
              <v-menu offset-y location="bottom">
                  <template v-slot:activator="{ props, on, isActive }">
                      <v-btn v-bind="props" v-on="{ ...on }" density="compact"
                          :style="isActive ? 'border-bottom-left-radius: 0px;border-bottom-right-radius: 0px;' : ''"
                          style="outline: none; font-size: 10px; " class="w-32 z-10 bg-dark text-light">
                          Actions
                          <v-icon icon="mdi-chevron-down" size="14"></v-icon>
                      </v-btn>
                  </template>
                  <v-list class="w-32 flex-1 flex flex-col px-0 py-0  z-0"
                      style="border-top-left-radius: 0px;border-top-right-radius: 0px">
                      <v-btn v-for="(button, index) in actionButtons" :key="index" @click="clickAction(item, button)"
                          rounded="0" class="text-center bg-dark text-light"
                          style="font-size: 10px; width: 128px; outline: none; border-bottom: 1px solid #345;"
                          :data-bs-toggle="button === 'Update' && 'modal'"
                          :data-bs-target="button === 'Update' && '#giftCodeUpdateModal'">
                          {{button }}
                      </v-btn>
                  </v-list>
              </v-menu>
          </template>
      </v-data-table>
  </div>
  <div>
      <AddNewOneDialog @close="addNewOneDialogFlag = false" />
      <UpdateInfoDialog :item="selectedItem" @updated="updatedHandler" />
  </div>
</template>
<script setup>
import { ref, onMounted, defineProps, onBeforeUnmount } from 'vue';
import { useGiftCodeStore, useAccountStore } from "@/stores"
import { storeToRefs } from 'pinia';
// import SearchBar from './SearchBar.vue';
import AddNewOneDialog from "./Modal/AddNewOneDialog.vue"
import UpdateInfoDialog from "./Modal/UpdateInfoDialog.vue"



const headers = ref(
  [
      { title: 'No', align: 'center', key: 'no' },
      { title: 'Gift Code', align: 'center', key: 'giftCode' },
      { title: 'Gift Amount', align: 'center', key: 'price' },
      { title: 'Coupon Code', align: 'center', key: 'couponCode' },
      { title: 'Redeem User', align: 'center', key: 'user' },
      { title: 'Redeem Date', align: 'center', key: 'redeem_date' },
      { title: 'Remain Price', align: 'center', key: 'remain_price' },
      { title: 'Actions', align: 'center', key: 'buttonBar' },
  ]
);
const viewList = ref(['Purchase', 'Redeem']);
const giftCodeStore = useGiftCodeStore()
const accountStore = useAccountStore()
const { GiftCodes, UserBalance } = storeToRefs(giftCodeStore)
const { user } = storeToRefs(accountStore)
giftCodeStore.loadGiftCodes();

const selectedView = ref("Purchase")
const addNewOneDialogFlag = ref(false)
const searchData = ref('')
const offsetHeight = 300; // Adjust this value as needed

const computedHeight = ref(window.innerHeight - offsetHeight);

const handleResize = () => {
computedHeight.value = window.innerHeight - offsetHeight;
};

onMounted(() => {
window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
window.removeEventListener('resize', handleResize);
});

const addGiftCode = () => {
  addNewOneDialogFlag.value = true
}

const actionButtons = ref(
  ["Delete"]
)

const updateInfoDialogFlag = ref(false)
const selectedItem = ref(null)

const openUpdateInfoDialog = (item) => {
  selectedItem.value = item
  updateInfoDialogFlag.value = true
}
const updatedHandler = () => {
  giftCodeStore.loadGiftCodes()
  updateInfoDialogFlag.value = false
}

const clickAction = (item, button) => {
  switch (button) {
    case "Update":
      openUpdateInfoDialog(item)
      break
    case "Delete":
      giftCodeStore.deleteGiftCode(item.giftCode).then(() => {
        giftCodeStore.loadGiftCodes()
      })

  }
}
</script>